// extracted by mini-css-extract-plugin
export default {"wechatMarkBox":"detail_wechatMarkBox__1F-un","wechatMarkBox_Content":"detail_wechatMarkBox_Content__hfzzr","arrow":"detail_arrow__YaojS"};